import { isEmpty } from 'lodash/fp';
import { Component as ReactComponent } from 'react';
import { Loader } from '@mews-commander/ui';
import { IconName } from '@optimus-web/core';
import ActionDropdown from '../../Common/ActionDropdown';

interface AsyncDropdownFactoryProps {
    icon: IconName;
    preLoading?: boolean;
    hideEmpty?: boolean;
}

interface AsyncDropdownProps {
    action: {
        text: string | JSX.Element;
    };
    component?: React.ComponentType;
    entities: unknown[];
    fetchEntities: () => void;
    isFetching: boolean;
}

export default ({ icon, preLoading = false, hideEmpty = false }: AsyncDropdownFactoryProps) =>
    <P extends {}>(Component: React.ComponentType<P>) =>
        class AsyncDropdown extends ReactComponent<AsyncDropdownProps & P> {
            componentDidMount() {
                if (preLoading && !this.props.isFetching) {
                    this.props.fetchEntities();
                }
            }

            render() {
                const { action, isFetching, component, entities, fetchEntities } = this.props;

                if (hideEmpty && isEmpty(entities)) {
                    return null;
                }

                const actionDropdownProps = {
                    icon,
                    title: action.text,
                    onOpen: fetchEntities,
                    component,
                    expandIcon: true,
                    ...action,
                };

                return (
                    <ActionDropdown {...actionDropdownProps}>
                        {isFetching ? <Loader /> : <Component {...this.props} />}
                    </ActionDropdown>
                );
            }
        };
